import React from "react";
import { ListItemButton, ListItemIcon, ListItemText, Typography } from "@mui/material";
import ChevronRightRounded from "@mui/icons-material/ChevronRightRounded";
import ExpandMoreRounded from "@mui/icons-material/ExpandMoreRounded";

/**
 * One tappable row under the mic. The icon in the brand colour, the current value and a chevron
 * on the right are what say "this is a button", without a border or a fill.
 */
const OptionRow = ({ icon, label, value, onClick, disabled = false, opensMenu = false, color }) => (
  <ListItemButton
    onClick={onClick}
    disabled={disabled}
    aria-haspopup={opensMenu ? "menu" : undefined}
    sx={{ borderRadius: 2, py: 1.25 }}
  >
    <ListItemIcon sx={{ minWidth: 40, color: color || "primary.main" }}>{icon}</ListItemIcon>
    <ListItemText primary={label} />
    {value && (
      <Typography variant="body2" color="text.secondary" sx={{ ml: 2, whiteSpace: "nowrap" }}>
        {value}
      </Typography>
    )}
    {/* No chevron on a row that cannot be used: it would still look like something to press. */}
    {disabled ? null : opensMenu ? (
      <ExpandMoreRounded fontSize="small" sx={{ ml: 1, color: "text.secondary" }} />
    ) : (
      <ChevronRightRounded fontSize="small" sx={{ ml: 1, color: "text.secondary" }} />
    )}
  </ListItemButton>
);

export default OptionRow;
